<script lang="ts">
    import IconImg from "./IconImg.svelte";

    import Plus from "../icons/PlusIcon.svelte";
    import Btn from "./Btn.svelte";
    import { t } from "../helpers/translation";
    export let color: string = "var(--yellow)";
    export let heading: string = "";
    export let icon: any;
    export let text: string;
    export let href: string;
</script>

<div class="page-preview-column" style="--color: {color};">
    <div class="inner">
        <div class="top-icon">
            <IconImg svg={icon} />
        </div>
        <div class="heading">{heading}</div>
        <hr />
        <p>{@html text}</p>
        <div class="link">
            <Btn {href} plus notupper>
                {@html $t("btn.readmore")}
            </Btn>
        </div>
    </div>
</div>

<style lang="scss">
    @import "./src/vars";

    .page-preview-column {
        border-right: 1px solid $yellow;
        margin-bottom: 4em;
        padding: 0 1.5em;
        min-height: 500px;
        @media (max-width: 800px) {
            min-height: unset;
            padding: 0;
            // margin-bottom: 1em;
        }
        :global(body.light) & {
            border: unset;
        }
        .inner {
            padding: 1.5em 1.5em;
            display: flex;
            flex-direction: column;
            background-color: $grayDark;
            height: 100%;
            border-radius: 1em;

            .heading,
            .top-icon {
                // filter: drop-shadow(0 0.2em 0.2em rgba(black, 0.25));
                margin-bottom: 0.25em;
            }
            .top-icon {
                font-size: 4em;
            }
            .heading {
                font-size: 1.7rem;
                font-weight: 600;
                text-transform: uppercase;
            }
            hr {
                border: none;
                border-bottom: 1px solid var(--color);
                margin: 1em 0em;
            }
            p {
                color: $gray;
            }
            .link {
                margin-top: auto;
            }

            :global(*) {
                color: var(--color);
            }
        }
    }
</style>
